import { ref } from 'vue'

// Fase 4.1 do plano de otimização de login (docs/planos/PLANO-OTIMIZACAO-LOGIN.md):
// registerServiceWorker.ts seta isso no hook `updated()`, quando o Workbox
// detecta que um novo Service Worker assumiu o controle da aba (skipWaiting +
// clientsClaim, ver vue.config.js) — ou seja, o bundle JS já carregado em
// memória ficou desatualizado de verdade em relação ao que está publicado.
// Login usa isso pra só limpar o cache do SW quando existe uma versão nova de
// fato, em vez de fazer isso incondicionalmente em todo login. Com o app aberto,
// a faixa AppUpdateBanner.vue avisa o agente (substitui o antigo botão "Atualizar").
export const appUpdateAvailable = ref(false)

export function markAppUpdateAvailable(): void {
  appUpdateAvailable.value = true
}

/**
 * Pede pro navegador conferir agora se há deploy novo (o SW novo, se houver, dispara `updated()` acima). Chamado
 * em momentos naturais — aba voltou a ficar visível, conexão em tempo real voltou —, nunca num intervalo fixo.
 */
export async function checkForAppUpdate(): Promise<void> {
  try {
    if (!('serviceWorker' in navigator)) return
    const registration = await navigator.serviceWorker.getRegistration()
    await registration?.update()
  } catch {
    /* sem rede ou SW indisponível (dev): tenta de novo no próximo momento natural */
  }
}

/** Troca pra versão nova: mesmo efeito do antigo botão "Atualizar" (Ctrl+F5 — SW e caches limpos, depois recarrega). */
export async function applyAppUpdate(): Promise<void> {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(registrations.map(r => r.unregister()))
    }
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map(k => caches.delete(k)))
    }
  } finally {
    window.location.reload()
  }
}
